/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0665/6770/0722/files/202512042-p1.png",
    "https://cdn.shopify.com/s/files/1/0665/6770/0722/files/202512042-p2.png",
    "https://cdn.shopify.com/s/files/1/0665/6770/0722/files/202512042-p3.png",
    "https://cdn.shopify.com/s/files/1/0665/6770/0722/files/202512042-p4.png",
    "https://cdn.shopify.com/s/files/1/0665/6770/0722/files/202512042-p5.png",
    "https://cdn.shopify.com/s/files/1/0665/6770/0722/files/202512042-p6.png",
    "https://cdn.shopify.com/s/files/1/0665/6770/0722/files/202512042-p7.png",

    "https://cdn.shopify.com/s/files/1/0665/6770/0722/files/202512042-b1.png",
    "https://cdn.shopify.com/s/files/1/0665/6770/0722/files/202512042-b2.png",
  ];

  // 顶部文字轮播
  new Swiper(".sp-swiper-fade", {
    spaceBetween: 10,
    effect: "fade",
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 3000,
    },
    speed: 1000,
    loop: true,
  });

  // // 按钮轮播
  // new Swiper(".sp-btn-loop", {
  //   spaceBetween: 10,
  //   autoplay: true,
  //   autoplay: {
  //     disableOnInteraction: false,
  //     reverseDirection: true,
  //   },
  //   loop: true,
  // });

  new Swiper(".sp-swiper2", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      // delay: 0,
    },
    // speed: 6000,
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: ".sp-swiper-btn-next",
      prevEl: ".sp-swiper-btn-prev",
    },
  });

  new Swiper(".sp-swiper2-m", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },

    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: ".sp-swiper-btn-next-m",
      prevEl: ".sp-swiper-btn-prev-m",
    },
  });

  let _swiper = new Swiper(".sp-swiper-pro", {
    speed: 1,
    spaceBetween: 0,
  });

  const $priceDom = $('#sp_price1');
  const $cPriceDom = $('#sp_price2');
  const $offPriceDom = $('.sp-price-group .sp-p span');
  const $numDom = $('#calcNumber');
  
  const productData = window.product || [];

  /** 获取当前选中的变量 */
  function getCur() {
    const opts = {
      option1: $('#sp-opt-group1 div.active').attr('data-val'),
      option2: $('#sp-opt-group2 div.active').attr('data-val'),
      option3: $('#sp-opt-group3 div.active').attr('data-val')
    };

    return productData.find(item => {
      return (!opts.option1 || item.option1 == opts.option1) &&
             (!opts.option2 || item.option2 == opts.option2) &&
             (!opts.option3 || item.option3 == opts.option3);
    });
  }

  /** 更新价格显示 */
  function changePrice() {
    const curVariant = getCur();
    console.log(curVariant)
    if (!curVariant) return;

    const num = parseInt($numDom.val()) || 1;
    
    // 识别当前页面使用的小数点符号
    const currentText = $priceDom.text().trim();
    const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/);
    
    const decimalSeparator = decimalMatch ? decimalMatch[1] : '.'; 
    const decimalLength = decimalMatch ? decimalMatch[2].length : 0; 

    // 格式化输出
    const formatValue = (cents) => {
      let val = (cents * num / 100).toFixed(decimalLength);
      if (decimalSeparator === ',') {
        val = val.replace('.', ',');
      }
      return val;
    };

    const price = formatValue(curVariant.price);
    const compare = formatValue(curVariant.compare_at_price);
    
    // 计算折扣
    let offPercent = 0;
    if (curVariant.compare_at_price > curVariant.price) {
      offPercent = 100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100);
    }

    const priceRegex = /\d+(?:[.,]\d+)*/;
    const offRegex = /(\d+)(?=(?:<[^>]+>|\s)*%)/g;

    const updateHTML = ($el, regex, value) => {
      if ($el && $el.length) {
        const text = $el[0].textContent.trim();
        const newHtml = text.replace(regex, value);
        if ($el.html() !== newHtml) {
          $el.html(newHtml);
        }
      }
    };

    updateHTML($priceDom, priceRegex, price);
    updateHTML($cPriceDom, priceRegex, compare);
    updateHTML($offPriceDom, offRegex, offPercent);
  }

  let sptextList = ["X2", "", "X2"];
  $(" .sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    let options1 = $(".sp-opt-group1 .sp-option.active").index();
    let options2 = $(".sp-opt-group2 .sp-option.active").index();
    console.log(options1, options2, options1 + options2 * 4)
    _swiper.slideToLoop(options1 + options2 * 4);


    changePrice();
  });

  $('.sp_buy_now ').on('click',function(){
    let num = $numDom.val();
    let id = getCur().id;
    window.location.href = '/cart/' + id + ':' + num;
  })

  function parsePrice(val) {
  if (!val) return 0;
  return Number(val.replace(',', '.'));
}

function formatPrice(val) {
  if (isNaN(val)) return '0,00';
  return val.toFixed(2).replace(',', '.');
}
function calcDiscount(price, comparePrice) {
  if (!comparePrice || comparePrice <= price) return 0;
  return Math.round((comparePrice - price) * 100 / comparePrice);
}
// function changePrice() {
//   let p = parsePrice($('.sp-option.active').attr('data-price'));
//   let cp = parsePrice($('.sp-option.active').attr('data-cprice'));
//   let num = Number($('.addGroup input').val());
//   let totalPrice = p * num;
//   let totalComparePrice = cp * num;
//   $('#sp_price1').text(formatPrice(totalPrice));
//   $('#sp_price2').text(formatPrice(totalComparePrice));

//   let discount = calcDiscount(totalPrice, totalComparePrice);
//   $('.sp-p2 .sp-span').text(discount);
// }

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
              }
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 处理所有锚点链接
    var links = document.querySelectorAll('a[href^="#"]');
    
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为

        var href = this.getAttribute('href');
        var targetId = href.substring(1); // 移除#号
        
        // 查找目标元素
        var targetElement = null;
        if (targetId === 'shopping') {
          targetElement = document.getElementById("shopping");
        } else if (targetId === 'GUARANTEES') {
          targetElement = document.getElementById("GUARANTEES");
        } else if (targetId === 'FAQ') {
          targetElement = document.getElementById("FAQ");
        } else if (targetId === '') {
          // 回到顶部
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        } else {
          targetElement = document.getElementById(targetId);
        }

        if (targetElement) {
          const offsetTop =
            document.body.clientWidth <= 1080
              ? targetElement.offsetTop - ($(".sp-nav").length ? $(".sp-nav").height() : 0)
              : targetElement.offsetTop;
          let sptop = document.body.clientWidth <= 1080 ? 0 : 70;
          let zoom = $("div#root").css("zoom");
          
          // PC端减30px，移动端加30px
          let offset = document.body.clientWidth <= 1080 ? 30 : -30;
          let finalTop = (offsetTop + offset) * zoom - sptop * zoom;

          // 使用多种滚动方法确保兼容性
          window.scrollTo({
            top: finalTop,
            behavior: "smooth"
          });

          if (typeof $ !== 'undefined') {
            $('html, body').animate({
              scrollTop: finalTop
            }, 800);
          }

          setTimeout(function() {
            document.documentElement.scrollTop = finalTop;
            document.body.scrollTop = finalTop;
          }, 100);
        }
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  // 从页面获取初始价格
  let originalPrice1 = 11.99; // 单价1的基础价格
  let originalPrice2 = 23.99; // 单价2的基础价格

  // 初始化时获取页面上的价格
  function initializePrices() {
    const price1Element = $("#sp_price1");
    const price2Element = $("#sp_price2");
    
    if (price1Element.length > 0) {
      originalPrice1 = parseFloat(price1Element.text()) || 11.99;
    }
    if (price2Element.length > 0) {
      originalPrice2 = parseFloat(price2Element.text()) || 23.99;
    }
  }

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }

  // 减号按钮点击事件
  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
      // 使用原始单价计算总价
      // $("#sp_price1").html(calcTotal(originalPrice1, input.value));
      // $("#sp_price2").html(calcTotal(originalPrice2, input.value));
      changePrice();
    }

  });

  // 加号按钮点击事件
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    // 使用原始单价计算总价
    // $("#sp_price1").html(calcTotal(originalPrice1, input.value));
    // $("#sp_price2").html(calcTotal(originalPrice2, input.value));

    changePrice();
  });

  // 输入框变化事件
  $("#calcNumber").on('input change', function() {
    let num = Number(this.value);
    if (num > 0) {
      // $("#sp_price1").html(calcTotal(originalPrice1, num));
      // $("#sp_price2").html(calcTotal(originalPrice2, num));
      changePrice();
    }
  });

  // 初始化价格
  initializePrices();

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  // 菜单
  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask").click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $(".sp-menu-mask").hide();
    // }
  });

  $('.sp-cart').on('click',function(){
    window.location.href="/cart";
  })

  // 滚动隐藏顶部
  if (
    $(window).scrollTop() >
    $(".sp_header").height() * $("div#root").css("zoom")
  ) {
    $(".sp_header-wrap").addClass("sp-fixed");
  } else {
    $(".sp_header-wrap").removeClass("sp-fixed");
  }

  // // 滚动添加底部
  // if (
  //   $(window).scrollTop() >
  //   $(".sp-part1").height() * $("div#root").css("zoom") -
  //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
  // ) {
  //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
  // } else {
  //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
  // }
  let spTimer = null;
  let spHasShown = false; // 防止重复显示

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $(".sp_header").height() * $("div#root").css("zoom")
    ) {
      $(".sp_header-wrap").addClass("sp-fixed");
    } else {
      $(".sp_header-wrap").removeClass("sp-fixed");
    }

    // 滚动添加底部
    if (spHasShown) return; // 已经显示就不再触发

    // 如果没有定时器，则开始计时
    if (!spTimer && $(window).scrollTop() > 800) {
      spTimer = setTimeout(function () {
        document.querySelector(".sp-btn-style2").style.display = "flex";
        spHasShown = true; // 标记为已显示
      }, 3000);
    }
    // if (
    //   $(window).scrollTop() >
    //   $(".sp-part1").height() * $("div#root").css("zoom") -
    //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
    // ) {
    //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
    // } else {
    //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
    // }
  });

  $(document).on("click", ".sp_buy_now", function () {
    console.log("xxx111");
  });

  let initNum = 0;
  $(document).on("click", ".sp_add_cart", function () {

    let curId = $('.sp-option.active').attr('data-id');

    let num = $('.addGroup input').val();
    var data = {
        id: curId,
        quantity: num,
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $('.sp-cart .num').html(result.item_count)
            $('.sp-cart .num').removeClass('sp-gray')
          })
        },
        dataType: 'json',
      })

    // 购物车加购动效

    $(this).children("img").addClass("on");
    $(".sp-cart .num").show();
    setTimeout(function () {
      $(" .cart-btn").children("img").removeClass("on");
    }, 500);
    
    // 根据设备类型选择不同的购物车
    if (document.body.clientWidth <= 1080) {
      $(".sp-mobile-sticky-cart").addClass("on");
      setTimeout(function () {
        $(".sp-mobile-sticky-cart").removeClass("on");
      }, 500);
    } else {
      $(".sp_pc .sp-cart").addClass("on");
      setTimeout(function () {
        $(".sp_pc .sp-cart").removeClass("on");
      }, 500);
    }

    let spNum = $(".sp_product_part #calcNumber")[0].value;
    initNum += Number(spNum);

    // $("#calcNumber").val(1);

    $(".cardNum").each(function () {
      $(this).html(initNum);
    });
    $(".cardNum").removeClass("sp-gray");
    // handleAddToCart(initNum);

    var imgs = $(".sp_product_part .swiper-slide-active").find("img");
    // var imgs = $(".sp_product_part .sp-img-p.active");

    imgs.each(function () {
      var $img = $(this);
      var flyer = $img[0].cloneNode(true);
      flyer.classList.add("sp_clone");

      $(".sp_product_part").append(flyer);
      $(flyer).css({
        width: $img[0].width,
        height: $img[0].height,
        background: "#e7e9ef",
        position: "fixed",

        top: $img[0].offsetTop,
        left: $img.offset().left,
        "z-index": 99,
      });
      let finish;
      if (document.body.clientWidth <= 1080) {
        finish = $(".sp-mobile-sticky-cart");

        $(flyer).animate(
          {
            top: $(".sp-mobile-sticky-bottom")[0].offsetTop + 40,
            left: finish.offset().left + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      } else {
        finish = $(".sp_pc .sp-cart");
        $(flyer).animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      }
    });
  });

  // 问答
  // 手风琴交互逻辑 (新增)
  $(".sp-qa1-faq-question").on("click", function () {
    var $currentItem = $(this).parent(".sp-qa1-faq-item"); // 当前点击的父级
    var $answer = $(this).next(".sp-qa1-faq-answer"); // 当前的答案部分
    var $icon = $(this).find(".sp-qa1-faq-icon"); // 当前的图标

    // 如果当前已经是打开的，则关闭它
    if ($currentItem.hasClass("active")) {
      $answer.slideUp();
      $currentItem.removeClass("active");
      $icon.removeClass("fa-minus").addClass("fa-plus");
    } else {
      // 如果当前是关闭的：

      // 1. 先关闭所有其他的项 (互斥效果)
      $(".sp-qa1-faq-item").removeClass("active");
      $(".sp-qa1-faq-answer").slideUp();
      $(".sp-qa1-faq-icon").removeClass("fa-minus").addClass("fa-plus");

      // 2. 展开当前项
      $currentItem.addClass("active");
      $answer.slideDown();
      $icon.removeClass("fa-plus").addClass("fa-minus");
    }
  });

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }
  // 文本渐出动画 - sp-ani2 (从右到左)
  const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`;
              span.style.animationDelay = `${index * 0.3 + 1}s`;
            });

            observerAni.unobserve(gradually3);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: '-100px 0px -100px 0px'
      }
    );
    observerAni.observe(gradually3);
  }

  // 文本渐出动画 - sp-ani3 (从左到右)
  const graduallyList4 = document.getElementsByClassName("sp-fade-box");
  for (let gradually4 of graduallyList4) {
    const paragraph4 = gradually4.querySelectorAll(".sp-ani3");

    const observerAni3 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph4.forEach((span, index) => {
              span.style.animation = `sp-fade-right 1s ease forwards`;
              span.style.animationDelay = `${index * 0.3 + 0.5}s`;
            });

            observerAni3.unobserve(gradually4);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: '-100px 0px -100px 0px'
      }
    );
    observerAni3.observe(gradually4);
  }

  // 轮播图功能 - 无限循环滑动效果
  const carouselSlides = document.querySelectorAll('.sp-carousel-slide');
  const carouselSlidesContainer = document.querySelector('.sp-carousel-slides');
  const arrowLeft = document.querySelector('.sp-carousel-arrow-left');
  const arrowRight = document.querySelector('.sp-carousel-arrow-right');
  
  if (carouselSlides.length > 0 && carouselSlidesContainer && arrowLeft && arrowRight) {
    const totalSlides = carouselSlides.length;
    let currentSlide = 1; // 从1开始，因为0是克隆的最后一张
    let isTransitioning = false;
    
    // 克隆第一张和最后一张以实现无限循环
    const firstClone = carouselSlides[0].cloneNode(true);
    const lastClone = carouselSlides[totalSlides - 1].cloneNode(true);
    
    carouselSlidesContainer.appendChild(firstClone);
    carouselSlidesContainer.insertBefore(lastClone, carouselSlides[0]);
    
    // 初始位置设置为第一张真实图片
    carouselSlidesContainer.style.transform = `translateX(-100%)`;
    
    function showSlide(index, transition = true) {
      if (transition) {
        carouselSlidesContainer.style.transition = 'transform 0.5s ease-in-out';
      } else {
        carouselSlidesContainer.style.transition = 'none';
      }
      
      const translateX = -(index * 100);
      carouselSlidesContainer.style.transform = `translateX(${translateX}%)`;
    }
    
    function handleTransitionEnd() {
      isTransitioning = false;
      
      // 如果在克隆的第一张（最右边），跳到真实的第一张
      if (currentSlide === totalSlides + 1) {
        currentSlide = 1;
        showSlide(currentSlide, false);
      }
      
      // 如果在克隆的最后一张（最左边），跳到真实的最后一张
      if (currentSlide === 0) {
        currentSlide = totalSlides;
        showSlide(currentSlide, false);
      }
    }
    
    carouselSlidesContainer.addEventListener('transitionend', handleTransitionEnd);
    
    function nextSlide() {
      if (isTransitioning) return;
      isTransitioning = true;
      currentSlide++;
      showSlide(currentSlide);
    }
    
    function prevSlide() {
      if (isTransitioning) return;
      isTransitioning = true;
      currentSlide--;
      showSlide(currentSlide);
    }
    
    arrowRight.addEventListener('click', nextSlide);
    arrowLeft.addEventListener('click', prevSlide);
    
    // 自动轮播
    let autoPlayInterval = setInterval(nextSlide, 5000);
    
    // 鼠标悬停时暂停自动轮播
    const carouselWrapper = document.querySelector('.sp-carousel-wrapper');
    if (carouselWrapper) {
      carouselWrapper.addEventListener('mouseenter', () => {
        clearInterval(autoPlayInterval);
      });
      
      carouselWrapper.addEventListener('mouseleave', () => {
        autoPlayInterval = setInterval(nextSlide, 5000);
      });
    }
  }

  // 移动端轮播图功能 - 无限循环滑动效果
  const mobileCarouselSlides = document.querySelectorAll('.sp-mobile-carousel-slide');
  const mobileCarouselSlidesContainer = document.querySelector('.sp-mobile-carousel-slides');
  const mobileArrowLeft = document.querySelector('.sp-mobile-carousel-arrow-left');
  const mobileArrowRight = document.querySelector('.sp-mobile-carousel-arrow-right');
  
  if (mobileCarouselSlides.length > 0 && mobileCarouselSlidesContainer && mobileArrowLeft && mobileArrowRight) {
    const mobileTotalSlides = mobileCarouselSlides.length;
    let currentMobileSlide = 1;
    let isMobileTransitioning = false;
    
    // 克隆第一张和最后一张以实现无限循环
    const mobileFirstClone = mobileCarouselSlides[0].cloneNode(true);
    const mobileLastClone = mobileCarouselSlides[mobileTotalSlides - 1].cloneNode(true);
    
    mobileCarouselSlidesContainer.appendChild(mobileFirstClone);
    mobileCarouselSlidesContainer.insertBefore(mobileLastClone, mobileCarouselSlides[0]);
    
    // 初始位置设置为第一张真实图片
    mobileCarouselSlidesContainer.style.transform = `translateX(-100%)`;
    
    function showMobileSlide(index, transition = true) {
      if (transition) {
        mobileCarouselSlidesContainer.style.transition = 'transform 0.5s ease-in-out';
      } else {
        mobileCarouselSlidesContainer.style.transition = 'none';
      }
      
      const translateX = -(index * 100);
      mobileCarouselSlidesContainer.style.transform = `translateX(${translateX}%)`;
    }
    
    function handleMobileTransitionEnd() {
      isMobileTransitioning = false;
      
      if (currentMobileSlide === mobileTotalSlides + 1) {
        currentMobileSlide = 1;
        showMobileSlide(currentMobileSlide, false);
      }
      
      if (currentMobileSlide === 0) {
        currentMobileSlide = mobileTotalSlides;
        showMobileSlide(currentMobileSlide, false);
      }
    }
    
    mobileCarouselSlidesContainer.addEventListener('transitionend', handleMobileTransitionEnd);
    
    function nextMobileSlide() {
      if (isMobileTransitioning) return;
      isMobileTransitioning = true;
      currentMobileSlide++;
      showMobileSlide(currentMobileSlide);
    }
    
    function prevMobileSlide() {
      if (isMobileTransitioning) return;
      isMobileTransitioning = true;
      currentMobileSlide--;
      showMobileSlide(currentMobileSlide);
    }
    
    mobileArrowRight.addEventListener('click', nextMobileSlide);
    mobileArrowLeft.addEventListener('click', prevMobileSlide);
    
    // 自动轮播
    let mobileAutoPlayInterval = setInterval(nextMobileSlide, 5000);
    
    // 触摸时暂停自动轮播
    const mobileCarouselWrapper = document.querySelector('.sp-mobile-carousel-wrapper');
    if (mobileCarouselWrapper) {
      mobileCarouselWrapper.addEventListener('touchstart', () => {
        clearInterval(mobileAutoPlayInterval);
      });
      
      mobileCarouselWrapper.addEventListener('touchend', () => {
        mobileAutoPlayInterval = setInterval(nextMobileSlide, 5000);
      });
    }
  }

  // Breathe Easy板块轮播图
  const breatheSwiper = new Swiper('.sp-breathe-swiper', {
    slidesPerView: 3,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.sp-breathe-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"></span>';
      },
    },
    slideToClickedSlide: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
        centeredSlides: true,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: true,
      },
    },
  });

  // 移动端Breathe Easy轮播图
  const mobileBreathSwiper = new Swiper('.sp-mobile-breathe-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.sp-mobile-breathe-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"></span>';
      },
    },
    slideToClickedSlide: true,
  });
});
